import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Card, Badge, Button, Form, Modal } from "react-bootstrap";
import { CreditCard, TrendingUp, Users, Plus, Edit2, X } from "lucide-react";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout ";
import "../../../assets/styles/admin/AdminSubscriptions.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

const AdminSubscriptions = () => {
  const [showCreatePlanModal, setShowCreatePlanModal] = useState(false);
  const [planName, setPlanName] = useState("");
  const [price, setPrice] = useState("");
  const [customerLimit, setCustomerLimit] = useState();
  const { baseUrl } = useContext(AppContext);
  // const [formData, setFormData] = useState({
  //   planName: '',
  //   price: '',
  //   customerLimit: ''
  // });

  const statsData = [
    {
      id: 1,
      title: "Total Subscribers",
      value: "156",
      icon: CreditCard,
      iconBg: "#dbeafe",
      iconColor: "#2563eb",
    },
    {
      id: 2,
      title: "Monthly Revenue",
      value: "Rs 3,42,500",
      icon: TrendingUp,
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
    {
      id: 3,
      title: "Paid Plans",
      value: "122",
      icon: Users,
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
  ];

  // ✅ isActive field add ki har plan mein
  const [plans, setPlans] = useState([])

  // const [plans, setPlans] = useState([
  //   {
  //     id: 1,
  //     name: "Free",
  //     price: 0,
  //     currency: "Rs",
  //     period: "/month",
  //     customerLimit: "Up to 10",
  //     subscribers: 34,
  //     borderColor: "#e5e7eb",
  //     isActive: true,
  //   },
  //   {
  //     id: 2,
  //     name: "Basic",
  //     price: 1500,
  //     currency: "Rs",
  //     period: "/month",
  //     customerLimit: "11-30",
  //     subscribers: 52,
  //     borderColor: "#3b82f6",
  //     isActive: true,
  //   },
  //   {
  //     id: 3,
  //     name: "Standard",
  //     price: 2500,
  //     currency: "Rs",
  //     period: "/month",
  //     customerLimit: "31-60",
  //     subscribers: 45,
  //     borderColor: "#10b981",
  //     isActive: true,
  //   },
  //   {
  //     id: 4,
  //     name: "Premium",
  //     price: 5000,
  //     currency: "Rs",
  //     period: "/month",
  //     customerLimit: "60+",
  //     subscribers: 25,
  //     borderColor: "#10b981",
  //     isActive: false,
  //   },
  // ]);

  // ✅ Toggle handler
  
  

const handleToggle = (plan) => {
  const newStatus = plan.status ? 0 : 1;
  const formData = new FormData();
  formData.append("id", plan.id);

    formData.append("status", newStatus);
  axios.post(`${baseUrl}/admin/subscriptionPlan/updateStatus`, formData)
    .then((res) => {
      Swal.fire("Done!", "Status updated", "success");
      viewAllPlans();
    })
    .catch((err) => {
      console.log(err);
    });
};
  

  const handleShowCreatePlan = () => setShowCreatePlanModal(true);

  const handleCloseCreatePlan = () => {
    setShowCreatePlanModal(false);
    setPlanName("");
    setPrice("");
    setCustomerLimit("");
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({ ...prev, [name]: value }));
  // };

  const addNewPlan = () => {
    // e.preventDefault();
    console.log("New plan:", planName, price, customerLimit);
    const formData = new FormData();
    formData.append("name", planName);
    formData.append("price", price);
    formData.append("customerlimit", customerLimit);
    axios
      .post(`${baseUrl}/admin/subscriptionPlan/addNewPlan`, formData, {
        "Content-header": "multipart-formdata",
      })
      .then((response) => {
        console.log("Response Called", response.data);
        if (response.data.success == true) {
          Swal.fire({
            title: "Congratulations!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "Cool",
          });
          handleCloseCreatePlan();
          viewAllPlans();
        } else if (response.data.success == false) {
          Swal.fire({
            title: "oops!",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "Exit",
          });
          handleCloseCreatePlan();
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  const viewAllPlans = () => {
    console.log("view all function called");
   
    axios.get(`${baseUrl}/admin/subcriptionPlan/viewAllPlans`)
    .then((response)=>{
      console.log("All Plan", response.data.subcriptionPlans);
      setPlans(response.data.subcriptionPlans);
    }).catch((error)=>{
      console.log(error);
    }).finally(()=>{});
  };

  useEffect(()=>{
    viewAllPlans();
  },[]);

  return (
    <AdminMasterLayout>
      <div className="admin-subscriptions-wrapper">
        {/* Page Header */}
        <div className="admin-subscriptions-header">
          <div>
            <h1 className="admin-subscriptions-title">Subscription Plans</h1>
            <p className="admin-subscriptions-subtitle">
              Manage distributor subscription tiers
            </p>
          </div>
          <Button
            className="admin-subscriptions-create-btn"
            onClick={handleShowCreatePlan}
          >
            <Plus size={18} strokeWidth={2.5} /> Create Plan
          </Button>
        </div>

        {/* Stats Cards */}
        <Row className="admin-subscriptions-stats-row g-3 g-lg-4">
          {statsData.map((stat, index) => (
            <Col xs={12} sm={6} lg={4} key={stat.id}>
              <Card
                className="admin-subscriptions-stat-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <Card.Body>
                  <div className="admin-subscriptions-stat-content">
                    <div
                      className="admin-subscriptions-stat-icon-box"
                      style={{ backgroundColor: stat.iconBg }}
                    >
                      <stat.icon
                        size={24}
                        style={{ color: stat.iconColor }}
                        strokeWidth={2}
                      />
                    </div>
                    <div className="admin-subscriptions-stat-info">
                      <span className="admin-subscriptions-stat-label">
                        {stat.title}
                      </span>
                      <h3 className="admin-subscriptions-stat-value">
                        {stat.value}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Subscription Plans Grid */}
        <Row className="admin-subscriptions-plans-row g-3 g-lg-4">
          {plans.map((plan, index) => (
            <Col xs={12} sm={6} lg={3} key={plan.id}>
              <Card
                className={`admin-subscriptions-plan-card${!plan.status ? " admin-subscriptions-plan-card--inactive" : ""}`}
                style={{
                  borderColor: plan.status ? plan.borderColor : "#e5e7eb",
                  animationDelay: `${index * 0.1}s`,
                }}
              >
                <Card.Body>
                  <div className="admin-subscriptions-plan-header">
                    <h3 className="admin-subscriptions-plan-name">
                      {plan.name}
                    </h3>
                    <div className="admin-subscriptions-plan-actions">
                      {/* ✅ Toggle switch */}
                      <label
                        className="admin-subscriptions-toggle"
                        title={
                          plan.status ? "Deactivate plan" : "Activate plan"
                        }
                      >
                        <input
                          type="checkbox"
                          checked={plan.status == 1}
                          onChange={() => handleToggle(plan)}
                        />
                        {/* <input
  type="checkbox"
  checked={plan.status == 1}
  onChange={() => handleToggle(plan)}
/> */}
                        <span className="admin-subscriptions-toggle-slider" />
                      </label>
                      <button className="admin-subscriptions-edit-btn">
                        <Edit2 size={16} />
                      </button>
                    </div>
                  </div>

                  {/* ✅ Active / Inactive badge */}
                  <div className="mb-2">
                    <span
                      className={`admin-subscriptions-status-badge admin-subscriptions-status-badge--${plan.status ? "active" : "inactive"}`}
                    >
                      {plan.status ? "Active" : "Inactive"}
                    </span>
                  </div>

                  <div className="admin-subscriptions-plan-price">
                    <span className="admin-subscriptions-currency">
                      {/* {plan.currency} */}
                      RS
                    </span>
                    <span className="admin-subscriptions-amount">
                      {plan.price.toLocaleString()}
                    </span>
                    <span className="admin-subscriptions-period">
                      {plan.period}
                    </span>
                  </div>

                  <div className="admin-subscriptions-plan-details">
                    <div className="admin-subscriptions-plan-detail">
                      <span className="admin-subscriptions-detail-label">
                        Customer Limit
                      </span>
                      <span className="admin-subscriptions-detail-value">
                        {plan.customerlimit}
                      </span>
                    </div>
                    <div className="admin-subscriptions-plan-detail">
                      <span className="admin-subscriptions-detail-label">
                        Subscribers
                      </span>
                      <Badge
                        bg="success"
                        className="admin-subscriptions-subscriber-badge"
                      >
                        {plan.subscribers}
                      </Badge>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Create Plan Modal */}
        <Modal
          show={showCreatePlanModal}
          onHide={handleCloseCreatePlan}
          centered
          className="admin-subscriptions-modal"
        >
          <Modal.Header className="admin-subscriptions-modal-header">
            <Modal.Title className="admin-subscriptions-modal-title">
              Create New Plan
            </Modal.Title>
            <button
              className="admin-subscriptions-modal-close"
              onClick={handleCloseCreatePlan}
            >
              <X size={20} />
            </button>
          </Modal.Header>
          <Modal.Body className="admin-subscriptions-modal-body">
            <Form>
              <Form.Group className="admin-subscriptions-form-group">
                <Form.Label className="admin-subscriptions-form-label">
                  Plan Name
                </Form.Label>
                <Form.Control
                  type="text"
                  name="planName"
                  placeholder="e.g. Enterprise"
                  value={planName}
                  onChange={(e) => {
                    setPlanName(e.target.value);
                  }}
                  className="admin-subscriptions-form-input"
                  required
                />
              </Form.Group>
              <Form.Group className="admin-subscriptions-form-group">
                <Form.Label className="admin-subscriptions-form-label">
                  Price (PKR / month)
                </Form.Label>
                <Form.Control
                  type="number"
                  name="price"
                  placeholder="e.g. 10000"
                  value={price}
                  onChange={(e) => {
                    setPrice(e.target.value);
                  }}
                  className="admin-subscriptions-form-input"
                  required
                />
              </Form.Group>
              <Form.Group className="admin-subscriptions-form-group">
                <Form.Label className="admin-subscriptions-form-label">
                  Customer Limit
                </Form.Label>
                <Form.Control
                  type="text"
                  name="customerLimit"
                  placeholder="e.g. 100+ or 61-100"
                  value={customerLimit}
                  onChange={(e) => {
                    setCustomerLimit(e.target.value);
                  }}
                  className="admin-subscriptions-form-input"
                  required
                />
              </Form.Group>
              <div className="admin-subscriptions-modal-footer">
                <Button
                  type="button"
                  className="admin-subscriptions-submit-btn"
                  onClick={addNewPlan}
                >
                  Create Plan
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </AdminMasterLayout>
  );
};

export default AdminSubscriptions;
